import { createRoutine } from "../utils/routine.utils";
export var requestInsurance = createRoutine("CONTRACT_REQUEST_INSURANCE");
export var requestMoveService = createRoutine("CONTRACT_REQUEST_MOVE_SERVICE");
